import { render } from "./HomeView.vue?vue&type=template&id=8426d3fe"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Oscar Daniel\\Desktop\\X LAUCHER\\TRABAJANDO\\05 - VUE\\Ejercio 2\\pasteleria-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__